module.exports = __webpack_public_path__ + "images/feature/20170214_3-39e3709c9180518e49c51798fc8409be.jpg";